<wm-datatable
  [id]="componentId"
  [loading]="searchLoading"
  [rows]="logEmails"
  [columns]="columns"
  [count]="page.totalElements"
  [offset]="page.pageNumber"
  [limit]="page.size"
  [params]="params"
  [translateToLegacy]="false"
  [showSimpleSearch]="true"
  [showFilterBuilder]="false"
  simpleSearchTitle="Search for emails"
  (settingsChanged)="handleSettingsChanged($event)"
  [sortField]="sortField"
  [sortDescending]="sortDescending"
  [actionColumns]="actionColumns"
  [defaultExportExludedColumns]="defaultExportExludedColumns"
  (columnOptionsChanged)="handleColumnOptionsChanged($event)"
  [availableColumns]="availableColumns"
></wm-datatable>

<ng-template #logEmailTmpl let-row="row" let-value="value">
  <wm-modal-confirm
    title="Log Email"
    (opened)="getLogEmail(row.logEmailId)"
    cancelText="Close"
    [moduleId]="row.logEmailId.toString()"
    [showButton]="true"
    [showButtonText]="true"
    buttonText="View"
    [buttonStyle]="ButtonStyle.Link"
  >
    <app-loader *ngIf="logEmailLoading"></app-loader>

    <div *ngIf="!logEmailLoading">
      <wm-log-email-view [logEmail]="logEmail"></wm-log-email-view>
    </div>
  </wm-modal-confirm>
</ng-template>

<ng-template #applicationActivityLinkTmpl let-row="row" let-value="value">
  <a
    [routerLink]="[
      '/application/workflow-application/',
      row.workflowApplicationId,
      row.workflowApplicationActivityDataId
    ]"
    target="_blank"
  >
    {{ value }}
  </a>
</ng-template>

<ng-template #erroredTmpl let-row="row" let-value="value">
  <span 
    *ngIf="value"
    class="chip m-0 bg-danger"
    style="color:white; pointer-events:none;"
  >
    Errored
  </span>
</ng-template>